module.exports = __webpack_public_path__ + "static/img/qiepian2.192c08f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiepian2.png
// module id = Fn9G
// module chunks = 2